import { render, staticRenderFns } from "./UserRoleDialog.vue?vue&type=template&id=2319a5be"
import script from "./UserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./UserRoleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports